import React from 'react'
import styled from 'styled-components'


export const Margin = ({ v = 0, h = 0 }) => <CustomDiv v={v} h={h} />

const CustomDiv = styled.div`
  height: ${({ v }) => v || 1}px;
  max-height: ${({ v }) => v || 1}px;
  width: ${({ h }) => h || 1}px;
  max-width: ${({ h }) => h || 1}px;
  display: ${({ h }) => (h ? 'inline-block' : 'block')}
`
